export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RejectDialog.vue?vue&type=template&id=08407b80&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/RejectDialog.vue?vue&type=template&id=08407b80&scoped=true
// module id = 1991
// module chunks = 31